import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-519d3b0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nickname" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 登录 ")

import { reactive, ref, onBeforeMount } from "vue"
import { useRouter } from "vue-router"
import { removeAll, setToken, setExpiresIn, setRefreshToken } from "@/utils/cookies"
import { showNotify } from "vant"
import { getPublicKey, encryptAPi, accountLogin } from "@/api/login"
import commons from "@/utils/commons"
interface ILoginForm {
  username: string
  password: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'logins',
  setup(__props) {

const router = useRouter()

const loading = ref<boolean>(false)
const loginForm = reactive<ILoginForm>({
  username: "cskjzcjyAdmin",
  password: "X2k@f478g!"
})

const handleLogin = async () => {
  loading.value = true
  await onGetPublicKey()
}

onBeforeMount(() => {
  removeAll()
})
// 获取公钥
const onGetPublicKey = async () => {
  const res: any = await getPublicKey()
  if (res.code == 200 && res.sucess) {
    // 加密
    var datas = {
      password: loginForm.password,
      publicKey: res.data.publicKey
    }
    encryptAPi(datas).then((response: any) => {
      if (response.code == 200 && response.sucess) {
        var newDatas = {
          password: response.data.encodePassword,
          systemId: commons.setT026(),
          username: loginForm.username
        }
        accountLogin(newDatas)
          .then((datas: any) => {
            loading.value = false
            if (datas.code == 200 && datas.sucess) {
              setToken(datas.data.access_token)
              setExpiresIn(datas.data.expires_in)
              setRefreshToken(datas.data.refresh_token)
              showNotify({ type: "success", message: "登录成功" })
              router.push({ path: "/home" })
            } else {
              showNotify({ type: "danger", message: datas.message || "登录失败" })
            }
          })
          .catch(() => {
            loading.value = false
            showNotify({ type: "danger", message: "网络错误" })
          })
      } else {
        loading.value = false
        showNotify({ type: "danger", message: response.message || "服务器错误" })
      }
    })
  } else {
    loading.value = false
    showNotify({ type: "danger", message: res.message || "服务器错误" })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: handleLogin,
      class: "van-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: loginForm.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.username) = $event)),
          left: "",
          clearable: "",
          placeholder: "请输入账号",
          class: "input_code",
          border: false,
          label: "账号",
          name: "账号",
          rules: [{ required: true, message: '请输入' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: loginForm.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
          left: "",
          clearable: "",
          placeholder: "请输入密码",
          class: "input_code",
          border: false,
          label: "密码",
          name: "密码",
          rules: [{ required: true, message: '请输入' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_button, {
          color: "#ffcd01",
          type: "primary",
          class: "yellow_button",
          "native-type": "submit",
          loading: loading.value,
          "loading-text": "提交中"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})